<template lang="pug">
  main
    NavBarGrupos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title.has-text-dark
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title  Sección para Grupo {{ grupo }} &nbsp
        br
        .columns.has-text-centered.is-centered.has-text-dark
          .column.is-3(v-show="isTPA_Facturas")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-invoice-dollar.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Facturas TPA
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Grupos/TPA/Facturas/Nueva") Entrar
          .column.is-3(v-show="isTPA_Facturas")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-invoice-dollar.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Facturas IRGE
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Grupos/IRGE/Facturas/Nueva") Entrar
          .column.is-3(v-show="!isTPA_Facturas || isUserGrupo")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-check.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Documentados TPA
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Grupos/TPA/Documentados") Entrar
          .column.is-3(v-show="!isTPA_Facturas || isUserGrupo")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-check.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Documentados IRGE
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Grupos/IRGE/Documentados") Entrar
          .column.is-3(v-show="isTPA_Facturas || !isUserGrupo")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-check.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Documentados IRGE
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/IRGE/SCA/Documentacion") Entrar
          .column.is-3(v-show="isTPA_Facturas || !isUserGrupo")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-check.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Documentados TPA
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Documentacion") Entrar
        .columns.column-blanco
</template>


<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarGrupos from '@/components/layout/NavBarGrupos.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'HomeGrupos',
    components: { Loader, NavBarGrupos },
    data () {
      return {
        isLoading: false,
        title: '',
        isTPA_Facturas: false,
        isUser_Propangol: false,
        isUser_Movenergy: false,
        isUser_Nieto: false,
        isUser_Metropolitano: false,
        isUser_Mabarak: false,
        isUser_Uribe: false,
        isUser_Soni: false,
        isUser_Global: false,
        isUser_MetroNieto: false,
        grupo: '',
        isUserGrupo: false
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerUser()
        this.title = `Aplicaciones para Grupo`
      },
      obtenerUser() {
        if (Object.keys(this.userLogin).length === 0) {
          this.$router.push('/')
        }

        switch (this.userLogin.cargo) {
          case '888':
            this.isTPA_Facturas = true
            this.isUser_Propangol = false
            this.isUser_Movenergy = false
            this.grupo = 'Propangol TPA'
            break
          case '880':
            this.isTPA_Facturas = false
            this.isUser_Propangol = true
            this.isUser_Movenergy = false
            this.grupo = 'Propangol'
            break
          case '881':
            this.isTPA_Facturas = false
            this.isUser_Movenergy = true
            this.isUser_Propangol = false
            this.grupo = 'Movenergy'
            break
          case '882':
            this.isTPA_Facturas = false
            this.isUser_Nieto = true
            this.isUser_Movenergy = false
            this.isUser_Propangol = false
            this.grupo = 'Nieto'
            break
          case '883':
            this.isTPA_Facturas = false
            this.isUser_Metropolitano = true
            this.isUser_Movenergy = false
            this.isUser_Propangol = false
            this.grupo = 'Metropolitano'
            break
          case '884':
            this.isTPA_Facturas = false
            this.isUser_Uribe = true
            this.isUser_Movenergy = false
            this.isUser_Propangol = false
            this.grupo = 'Uribe'
            break
          case '885':
            this.isTPA_Facturas = false
            this.isUser_Mabarak = true
            this.isUser_Movenergy = false
            this.isUser_Propangol = false
            this.grupo = 'Mabarak'
            break
          case '886':
            this.isTPA_Facturas = false
            this.isUser_Soni = true
            this.isUser_Movenergy = false
            this.isUser_Propangol = false
            this.grupo = 'Sonigas'
            break
          case '8822':
            this.isTPA_Facturas = false
            this.isUser_Global = true
            this.isUser_Movenergy = false
            this.isUser_Propangol = false
            this.grupo = 'Global'
            break
          case '8823':
            this.isTPA_Facturas = false
            this.isUser_MetroNieto = true
            this.isUser_Movenergy = false
            this.isUser_Propangol = false
            this.grupo = 'Metro-Nieto'
            break
          case '345':
            this.isTPA_Facturas = true
            this.isUser_MetroNieto = false
            this.isUser_Movenergy = false
            this.isUser_Propangol = false
            this.grupo = 'Metro-Nieto'
            break
          default:
            this.isTPA_Facturas = false
            this.isUser_Propangol = false
            this.isUser_Movenergy = false
            this.isUser_Nieto = false
            this.isUser_Metropolitano = false
            this.isUser_Mabarak = false
            this.isUser_Uribe = false
            this.isUser_Soni = false
            this.isUser_Global = false
            this.isUser_MetroNieto = false
            break
        }

        if (this.isUser_Global || this.isUser_MetroNieto || this.isUser_Nieto || this.isUser_Metropolitano || this.isUser_Mabarak || this.isUser_Uribe || this.isUser_Soni || this.isUser_Propangol || this.isUser_Movenergy) {
          this.isUserGrupo = true
        } else {
          this.isUserGrupo = false
        }

        // if (this.userLogin.cargo ==='880' && this.userLogin.ubicacion === 'TPA') {
        //   this.isTPA_Facturas = true
        // }
      },
      irSca () {
        location.href = '/SCA_Tuxpan/principal.html'
      }
    },
    created () {
      this.obtenerUser()
    },
    computed: {
    ...mapState(['logueado', 'userLogin'])
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }

  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
  .card {
    color: #54545c;
  }
</style>


// WEBPACK FOOTER //
// src/components/HomeGrupos.vue